import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { SpinWheelRegionEntity } from '../../domain/entities/SpinWheelRegionEntity'
import type { SpinWheelRegionAdminDto } from '@/backend/market'
import { RegionMiniModel } from '@/features/region/data/models/RegionMiniModel'

export class SpinWheelRegionModel extends SpinWheelRegionEntity {
  constructor(dataDto: SpinWheelRegionAdminDto) {
    super()
    mapEntityProperties<SpinWheelRegionEntity>(this, dataDto, {
      exclude: ['region'],
      map: {
        region: new RegionMiniModel({
          id: dataDto.id,
          name: dataDto.name
        }),
        districtIds: dataDto.districtIds || []
      }
    })
  }
}
